import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../Assets/logo.svg';
import './Success.css';

const Success = () => {
    const navigate = useNavigate();

    return (
        <div className="page">
            <div className="container">
                <div className="card">
                    <div className="card-header">
                        <img src={logo} alt="Logo" className="logo" />
                    </div>

                    <div className="content">
                        <div className="icon">
                            <svg viewBox="0 0 24 24" fill="none">
                                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                                <path d="M8 12l2.5 2.5L16 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>

                        <h1>Application Submitted</h1>
                        <p>Your admission application has been received. We will review and contact you soon.</p>

                        <button onClick={() => navigate('/')}>
                            Submit Another Application
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Success;
